import { isString } from './isString';

import { LOCALE } from '../constants';

export function upperFirst(input, locale = LOCALE) {
  if (!isString(input)) return '';
  return input.replace(/(^[a-z])/, (match) => match.toLocaleUpperCase(locale));
}
